const METRICS_PREFIX = 'METRICS_';

export const FETCH_METRICS_REQUEST = METRICS_PREFIX + 'FETCH_REQUEST';
export const FETCH_METRICS_SUCCESS = METRICS_PREFIX + 'FETCH_SUCCESS';
export const FETCH_METRICS_FAILURE = METRICS_PREFIX + 'FETCH_FAILURE';
export const CLEAR_METRICS_CACHE = METRICS_PREFIX + 'CLEAR_CACHE';

// VDS unified all-metrics (single call for all 8 tiles)
export const FETCH_ALL_METRICS_REQUEST = METRICS_PREFIX + 'FETCH_ALL_REQUEST';
export const FETCH_ALL_METRICS_SUCCESS = METRICS_PREFIX + 'FETCH_ALL_SUCCESS';
export const FETCH_ALL_METRICS_FAILURE = METRICS_PREFIX + 'FETCH_ALL_FAILURE';
